import imagesPillarPages from '../imagesPillarPages';

export default {
  headingText: {
    title: `Leverage the power of cryptocurrencies and decentralized finance`,
    description: `Develop advanced cryptocurrency applications and trading platforms
     using cutting-edge technology to rule the decentralized world. We’ve built digital
      asset storing, transferring, trading and exchanging software–use our experience to develop your own solution.`,
    img: imagesPillarPages.bitcoinPillar
  },
  carouselImages: [
    {
      src: 'pages/bitcoin.png',
      alt: 'bitcoin',
      title: 'bitcoin'
    },
    {
      src: 'pages/Dash_cryptocurrency_logo.png',
      alt: 'cryptocurrency',
      title: 'cryptocurrency'
    },
    {
      src: 'pages/Eos_logo.png',
      alt: 'Eos',
      title: 'Eos'
    },
    {
      src: 'pages/imageedit.png',
      alt: 'quorum',
      title: 'quorum'
    },
    { src: 'pages/ripple.png', alt: 'ripple', title: 'ripple' },
    { src: 'pages/Ethereum-logo.png', alt: 'Ethereum', title: 'Ethereum' }
  ],
  carouselImages2: [
    {
      src: 'pages/chainalysis.png',
      alt: 'chainalysis',
      title: 'chainalysis'
    },
    {
      src: 'pages/onfido.png',
      alt: 'onfido',
      title: 'onfido'
    },
    {
      src: 'pages/Vo1t.png',
      alt: 'Vo1t',
      title: 'Vo1t'
    }
  ],
  checkmarkColumnsData: [
    {
      title: 'Cryptocurrency wallet development',
      subtitle:
        'The number of cryptocurrency wallet users is increasing rapidly. Allow your users to send and receive cryptocurrencies and have a track on crypto balance. Let us take care of all security standards, multi-factor authentication or duplicate payments denial.'
    },
    {
      title: 'Smart contract development',
      subtitle:
        'Develop a highly optimized smart contract for your business use case. Our blockchain developers help to create and adapt the smart contract protocols with customized and outstanding features.'
    },
    {
      title: 'Cryptocurrency exchange development',
      subtitle:
        'Build secure, flexible, and customizable cryptocurrency exchange software solutions for easier and faster transactions. Our developers create crypto platforms with powerful matching engine systems where you can list unlimited tradable assets including digital assets, fiat currencies, forex and equities.'
    },
    {
      title: 'Off-chain service development',
      subtitle:
        'Don’t forget that we are a full-stack software development company. Off-chain applications are our specialty. Our engineers use leading-edge technology to enable financial markets to grow.'
    },
    {
      title: 'KYC and AML integrations',
      subtitle:
        'Do you need to ensure the legitimacy of your clients and funds? Or the compliance with the current law is the top priority for you? We help you to verify the identity of a client and comply with global anti-money laundering policies. Mitigate risk, improve security and protect your business. Effectively.'
    },
    {
      title: 'Cold storage integration',
      subtitle:
        'Are you keeping large amounts of your customers’ funds? Then, integration with cold wallets is a must-have. Fortunately, we have it covered!'
    }
  ],
  telecomSectionData1: {
    title: 'Get top blockchain engineers for your FinTech project',
    description: [
      'Choosing the right technology partner for your business is not easy.',
      'At Ulam Labs, we assist you in each step of the cryptocurrency software development, from the idea, through planning, across the development stage, till the release.'
    ],
    list: [
      'since 2012 on the market',
      '20+ successful projects',
      'Startups and SME oriented',
      'All range of industries: Fintech, Telco, E-commerce, and more...'
    ],
    btnText: "Let's work together"
  },
  testimonialText: {
    customTitle:
      'What our clients say about our cryptocurrency development services?',
    customSubtitle:
      'Founders, SEOs and top managers from all over the world value our service especially for smooth communication, expertise and timely product delivery. Read custom opinions which prove that we are a perfect technology partner for you as well.'
  }
};
